import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { GoogleMap } from '@react-google-maps/api';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import GoogleMapsProvider from '../../../bundles/shared/GoogleMapsProvider';

const MapWithMarkerClusters = ({ lat, lon, height = "200px", geoCoordinates }) => {
  const [map, setMap] = useState(null);
  const [clusterer, setClusterer] = useState(null);
  const [markers, setMarkers] = useState([]);

  const mapContainerStyle = {
    width: '100%',
    height: '100%'
  };

  const center = {
    lat: parseFloat(lat),
    lng: parseFloat(lon)
  };

  const options = {
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    panControl: false,
    rotateControl: false,
    fullscreenControl: false,
    maxZoom: 8,
    mapId: "MAP_WITH_MARKER_CLUSTERS"
  };

  useEffect(() => {
    if (!map) return;

    const initMarkers = async () => {
      if (clusterer) {
        clusterer.clearMarkers();
      }
      markers.forEach(marker => marker.setMap(null));

      const validCoordinates = geoCoordinates
        .map(location => ({
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng)
        }))
        .filter(point => !isNaN(point.lat) && !isNaN(point.lng));

      const newMarkers = validCoordinates.map(point =>
        new google.maps.Marker({
          position: point,
          map
        })
      );

      if (clusterer) {
        clusterer.clearMarkers();
        clusterer.addMarkers(newMarkers);
      } else {
        const newClusterer = new MarkerClusterer({
          map,
          markers: newMarkers
        });
        setClusterer(newClusterer);
      }

      setMarkers(newMarkers);
    };

    initMarkers();

    return () => {
      markers.forEach(marker => marker.setMap(null));
      if (clusterer) {
        clusterer.clearMarkers();
      }
    };
  }, [map, geoCoordinates]);

  return (
    <GoogleMapsProvider>
      <div style={{ height }}>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={3}
          options={options}
          onLoad={setMap}
        />
      </div>
    </GoogleMapsProvider>
  );
};

MapWithMarkerClusters.propTypes = {
  lat: PropTypes.string.isRequired,
  lon: PropTypes.string.isRequired,
  height: PropTypes.string,
  geoCoordinates: PropTypes.array.isRequired
};

export default MapWithMarkerClusters;
